import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivateChild {
  constructor(private router: Router, private userService: UserService) {}

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Promise<boolean> {
    return !!this.userService.user || this.redirect(route, state);
  }

  private redirect(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): UrlTree | Promise<boolean> {
    let venueId = route.queryParamMap.get('venueId');
    const isPredict = state.url.includes('predict-and-win');
    if (isPredict) {
      venueId = this.getRoute(route)?.paramMap.get('venueId');
    }
    if (venueId) {
      return this.router.navigate(['/auth'], {
        queryParams: {
          redirectTo: isPredict
            ? `my/predict-and-win/${venueId}`
            : `my/builder/dashboard/leaderboard?venueId=${venueId}`,
        },
      });
    } else {
      return this.router.parseUrl('/auth');
    }
  }

  private getRoute(route: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
    if (!route?.firstChild) {
      return route;
    }
    const r = route.firstChild;
    return this.getRoute(r);
  }
}
